import axios from "axios";

const EmpDiscripencyService = {
  // Fetch all locations
  async getLocations() {
    try {
      const response = await axios.get(
        `/UserDetails/Locations`,
        { headers: {} }
      );
      console.log("Locations API response:", response.data);

      if (response.data && response.data.statusCode === 200) {
        return Array.isArray(response.data.resultSet)
          ? response.data.resultSet
          : [];
      }

      return Array.isArray(response.data.resultSet)
        ? response.data.resultSet
        : [];
    } catch (error) {
      console.error("Error fetching Locations:", error);
      throw error;
    }
  },

  // Fetch attendance summary for all locations
  async getAttendanceSummary(date) {
    try {
      const response = await axios.get(
        `/UserDetails/GetAttendenceDetailsForDay?today=${date}`,
        { headers: {} }
      );
      console.log("Attendance Summary API response:", response.data);

      if (response.data && response.data.statusCode === 200) {
        return Array.isArray(response.data.resultSet)
          ? response.data.resultSet
          : [];
      }

      return Array.isArray(response.data.resultSet)
        ? response.data.resultSet
        : [];
    } catch (error) {
      console.error("Error fetching Attendance Summary:", error);
      throw error;
    }
  },

  // Fetch absent details with date and location
  async getAll(date, location) {
    try {
      const response = await axios.get(
        `/UserDetails/GetAbsentDetailsForDaywithL?today=${date}&location=${location}`,
        { headers: {} }
      );
      console.log("API response:", response.data);

      if (response.data && response.data.statusCode === 200) {
        return Array.isArray(response.data.resultSet)
          ? response.data.resultSet
          : [];
      }

      return Array.isArray(response.data.ResultSet)
        ? response.data.ResultSet
        : [];
    } catch (error) {
      console.error("Error fetching Employee Absent Details:", error);
      throw error;
    }
  },
};

export default EmpDiscripencyService;


// import axios from "axios";

// const EmpDiscripencyService = {
//   // Fetch attendance summary for all locations
//   async getAttendanceSummary(date) {
//     try {
//       const response = await axios.get(
//         `/UserDetails/GetAttendenceDetailsForDay?today=${date}`,
//         { headers: {} }
//       );
//       console.log("Attendance Summary API response:", response.data);

//       if (response.data && response.data.statusCode === 200) {
//         return Array.isArray(response.data.resultSet)
//           ? response.data.resultSet
//           : [];
//       }

//       return Array.isArray(response.data.resultSet)
//         ? response.data.resultSet
//         : [];
//     } catch (error) {
//       console.error("Error fetching Attendance Summary:", error);
//       throw error;
//     }
//   },

//   // Fetch absent details with date and location
//   async getAll(date, location) {
//     try {
//       const response = await axios.get(
//         `/UserDetails/GetAbsentDetailsForDaywithL?today=${date}&location=${location}`,
//         { headers: {} }
//       );
//       console.log("API response:", response.data);

//       if (response.data && response.data.statusCode === 200) {
//         return Array.isArray(response.data.resultSet)
//           ? response.data.resultSet
//           : [];
//       }

//       return Array.isArray(response.data.ResultSet)
//         ? response.data.ResultSet
//         : [];
//     } catch (error) {
//       console.error("Error fetching Employee Absent Details:", error);
//       throw error;
//     }
//   },
// };

// export default EmpDiscripencyService;